import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";

const TaxFilingServices = ({ data }) => {
  return (
    <>
      <div className="container">
        <Title
          className="bbc-title mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-700"
          text={data.title}
          as="h2"
        />
        <p className="mb-6 text-left font-medium lg:mb-20 lg:text-center lg:font-normal">
          {data.subTitle}
        </p>
        <ul className="block list-disc pl-5 text-base lg:hidden">
          <li>VAT, CIT, PIT on the quarterly or monthly basis</li>
          <li>CIT or PIT’s annual finalization</li>
          <li>Annual license tax</li>
          <li>Monthly or quarterly report for using invoice</li>
        </ul>
        <div className="block py-4 px-0 lg:hidden lg:px-4">
          <p className="mb-2 text-base font-normal leading-6">
            Plus, registering for a personal tax code is also an essential part
            that needs to be taken care of.
          </p>
          <p className=" text-base font-normal leading-6">
            Let BBCIncorp do all the hassles for you by completing all the
            filing compliance on your behalf!
          </p>
        </div>
        <div className="mb-7 flex justify-center">
          <div
            className="lg:shadow-bbc relative rounded-lg shadow-none "
            style={{ maxWidth: "540px" }}
          >
            <Img
              src="assets/images/vn/accounting-and-auditing/tax_filing-vn-accounting.png"
              alt="tax-filing-services"
              loading="eager"
              className="rounded-none lg:rounded-t-lg "
              width={540}
              height={304}
            />
            <div className="hidden py-4 px-0 lg:block lg:px-4">
              <p className="mb-2 text-base font-normal italic leading-6 lg:mb-1 lg:text-sm">
                Plus, registering for a personal tax code is also an essential
                part that needs to be taken care of.
              </p>
              <p className=" text-base font-normal italic leading-6 lg:text-sm">
                Let BBCIncorp do all the hassles for you by completing all the
                filing compliance on your behalf!
              </p>
            </div>
            <p className={`shadow-bbc absolute hidden ${styles.item}`}>
              VAT, CIT, PIT on the quarterly or monthly basis
            </p>
            <p className={`shadow-bbc absolute hidden ${styles.item}`}>
              CIT or PIT’s annual finalization
            </p>
            <p className={`shadow-bbc absolute hidden ${styles.item}`}>
              Annual license tax
            </p>
            <p className={`shadow-bbc absolute hidden ${styles.item}`}>
              Monthly or quarterly report for using invoice
            </p>
          </div>
        </div>
        <div className="text-center">
          <ButtonNew
            onClick={async () => {
              // eslint-disable-next-line no-undef
              await Tawk_API.toggle();
            }}
          >
            Tell Us Your Case
          </ButtonNew>
        </div>
      </div>
    </>
  );
};

export default TaxFilingServices;

TaxFilingServices.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
};

TaxFilingServices.defaultProps = {
  data: [],
  children: <></>,
};
